import { useMutation } from "@tanstack/react-query";
import api from "../../../api";
import urls from "../../../urls";
import type { Generator } from "../../../utils/backend-types";

export function useGeneratorMutation(siteId: number) {
  const createMutation = useMutation({
    mutationFn: (data: Record<string, unknown>) =>
      api.post<Generator>(urls.api.generators({ siteId }), data)
  });

  return { createMutation };
}
